window.csT=window.csT||function(k,d){return (window.csI18n&&window.csI18n[k])||d;};
/* Clightstore product cards outside the collection page: quick add to cart, quantity, variants, carousel arrows,
   lazy-loaded related products. Forms inside [data-csc] are handled by cs-collection.js. */
(() => {
  if (window.__csCards) return; window.__csCards = true;
  const outside = (el) => !el.closest('[data-csc]:not(.csc--row)');
  let toast, toastT;
  const showToast = (html, err) => {
    if (!toast) { toast = document.createElement('div'); toast.className = 'csc__toast'; toast.setAttribute('role', 'status'); toast.setAttribute('aria-live', 'polite'); toast.style.cssText = '--blue:#1c61e7'; document.body.appendChild(toast); }
    toast.innerHTML = html; toast.classList.toggle('is-error', !!err); toast.hidden = false;
    clearTimeout(toastT); toastT = setTimeout(() => { toast.hidden = true; }, 4000);
  };
  const money = (cents) => { try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100); } catch { return (cents / 100).toFixed(2); } };
  async function refreshCart() {
    try {
      const cart = await (await fetch('/cart.js', { credentials: 'same-origin' })).json();
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'cs-card', data: { itemCount: cart.item_count, source: 'cs-card' } } }));
      document.querySelectorAll('[class*="cart-bubble"] [class*="count"], [data-cart-count], .cart-count').forEach(el => { el.textContent = cart.item_count; });
    } catch {}
  }
  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-csc-buy] [data-q]');
    if (q && outside(q)) { const inp = q.closest('form').querySelector('input[name="quantity"]'); inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(q.dataset.q, 10)); return; }
    const a = e.target.closest('.csr__arrow');
    if (a) { const tr = a.closest('[data-cs-row]').querySelector('[data-cs-track]'); tr.scrollBy({ left: tr.clientWidth * 0.9 * parseInt(a.dataset.dir, 10), behavior: 'smooth' }); }
  });
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-csc-buy] .csc__variant');
    if (sel && outside(sel)) {
      const card = sel.closest('.csc__card'), opt = sel.selectedOptions[0];
      const pr = card.querySelector('[data-csc-price]'), from = card.querySelector('[data-csc-from]');
      if (pr && opt) { delete pr.dataset.csOrig; delete pr.dataset.csSet; pr.textContent = money(+opt.dataset.cents); }
      if (from) from.hidden = true;
    }
    const qi = e.target.closest('[data-csc-buy] input[name="quantity"]');
    if (qi) qi.value = Math.max(1, parseInt(qi.value, 10) || 1);
  });
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-csc-buy]');
    if (!form || !outside(form)) return;
    e.preventDefault();
    const btn = form.querySelector('.csc__add'), label = btn.querySelector('.csc__add-label');
    if (btn.disabled || btn.classList.contains('is-loading')) return;
    const id = form.querySelector('[name="id"]').value, quantity = Math.max(1, parseInt(form.querySelector('[name="quantity"]').value, 10) || 1);
    btn.classList.add('is-loading'); label.textContent = 'Adding…';
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity }] }) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.description || d.message || (csT('could_not_add_to_cart',(csT('could_not_add_to_cart',"Could not add to cart")))));
      btn.classList.remove('is-loading'); btn.classList.add('is-added'); label.textContent = (csT('added',(csT('added',"Added"))));
      const title = form.closest('.csc__card').querySelector('.csc__title').textContent.split(' – ')[0];
      showToast(`<span>${quantity} × ${title.replace(/</g, '&lt;')} added to your cart</span><a href="/cart">View cart</a>`);
      refreshCart();
      setTimeout(() => { btn.classList.remove('is-added'); label.textContent = (csT('add_to_cart',(csT('add_to_cart',"Add to cart")))); }, 1800);
    } catch (err) {
      btn.classList.remove('is-loading'); label.textContent = (csT('add_to_cart',(csT('add_to_cart',"Add to cart"))));
      showToast(String(err.message || err).replace(/</g, '&lt;'), true);
    }
  });
  // Related products: fetch the section rendered with recommendations
  const loadRecs = () => document.querySelectorAll('[data-cs-rec]').forEach(async (row) => {
    if (row.dataset.loaded) return; row.dataset.loaded = '1';
    try {
      const html = await (await fetch(row.dataset.csRec)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cs-row]');
      const track = fresh && fresh.querySelector('[data-cs-track]');
      if (track && track.children.length) row.querySelector('.csc__in').replaceWith(fresh.querySelector('.csc__in'));
      else row.hidden = true;
    } catch { row.hidden = true; }
  });
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', loadRecs) : loadRecs();
})();
